import { cn } from "@/app/lib/utils";

interface WordmarkProps {
  /**
   * Optional custom className to apply to the wordform
   */
  className?: string;
  /**
   * Optional size variant
   */
  size?: "sm" | "default" | "lg" | "xl";
  /**
   * Optional color variant
   */
  variant?: "default" | "muted";
}

/**
 * SpinDoctor wordform component for consistent brand representation
 *
 * @example
 * ```tsx
 * // Default usage
 * <Wordmark />
 *
 * // With custom size
 * <Wordmark size="lg" />
 *
 * // With muted variant
 * <Wordmark variant="muted" />
 * ```
 */
export function Wordmark({
  className,
  size = "default",
  variant = "default",
}: WordmarkProps) {
  return (
    <span
      className={cn(
        "font-bold tracking-tighter inline-flex items-center rounded",
        size === "sm" && "text-base",
        size === "default" && "text-lg",
        size === "lg" && "text-2xl",
        size === "xl" && "text-2xl sm:text-3xl md:text-4xl lg:text-5xl",
        variant === "default" && "text-foreground",
        variant === "muted" && "text-muted-foreground",
        className
      )}
    >
      <span className="text-primary font-black">Spin</span>
      <span className="text-secondary font-black">Doctor</span>
    </span>
  );
}
